<script>
export default {
  name: 'PageNotFound',
};
</script>

<template>
  <div class="page">
    <h1>Page not found</h1>
    <p>We could not find the content you were looking for.</p>
  </div>
</template>

<style lang="scss" scoped>
.page {
  @include page-padding;
  max-width: $page-width;
}
</style>
